import React, {Component} from 'react';
import './App.css';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField'
import Button from "@material-ui/core/Button";
import MUIDataTable from "mui-datatables";
import axios from "axios";
import {withSnackbar} from 'notistack';
import {bffUrl} from './config.js'
import {Card, CardContent} from "@material-ui/core";
import {DateTime} from 'luxon';

const styles = theme => ({
    container: {
        position: 'relative',
    },
});


class TranscodingHelperContainer extends Component {

    constructor(props) {

        super(props);

        this.state = {
            cid: '',
            downloadableSourceUrlData: [],
            refreshMinutes: 10
        };

    }

    handleChange = element => event => {
        this.setState({
            [element]: event.target.value,
        }, function () {

        });
    };

    componentDidMount() {
        this.requestsLoader();

        let self = this;
    }

    snackBarCloseHandler = () => {
        this.setState({
            snackBarOpen: false
        })
    };

    requestsLoader = () => {

        var userEmail = sessionStorage.getItem("userEmail");

        const {cid, refreshMinutes} = this.state;
        const downloadRequestUrl = `${bffUrl}/TranscodingRequest?sort=createdAt%20DESC&limit=10000`;
        const getDownloadRequest = axios.create({
            baseURL: downloadRequestUrl,
            timeout: 150000
        });
        getDownloadRequest.get()
            .then(response => {
                if (response.data) {
                    response.data.map(responseData => {
                        responseData.updatedAt = DateTime.fromMillis(responseData.updatedAt).toLocaleString(DateTime.DATETIME_MED);
                        return responseData;
                    });
                    this.setState({
                        downloadableSourceUrlData: response.data
                    }, () => {

                    })

                } else {
                    this.props.enqueueSnackbar('Data Does not Exist.', {
                        variant: 'warning', anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'center',
                        }
                    });
                }
            })
            .catch(err => {
                this.props.enqueueSnackbar('Error Occurs During Process.', {
                    variant: 'warning', anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center',
                    }
                });
            });

    };


    getDownloadableUrl = (event) => {

        this.setState({
            downloadableSourceUrlData: []
        });
        var userEmail = sessionStorage.getItem("userEmail");

        const {cid, refreshMinutes, source, target, suffix} = this.state;

        if (cid === "") {
            this.props.enqueueSnackbar('Please Enter Cid!!', {
                variant: 'warning', anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                }
            });
            return;
        }

        var cidArray = cid.split(",");

        if (cidArray.length > 1) {
            this.props.enqueueSnackbar('Only One Cid Allow At a Time!!', {
                variant: 'warning', anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                }``
            });
            return;
        }

        if (cid !== "") {
            const baseUrl = `${bffUrl}/ingestion/transcodingRequest?cid=${cid}&email=${userEmail}&source=${source}&target=${target}&suffix=${suffix}`;

            const getDownloadableUrl = axios.create({
                baseURL: baseUrl,
                timeout: 150000
            });

            getDownloadableUrl.get()
                .then(res => {
                    if (res.data) {
                        this.requestsLoader();
                        setInterval(() => {
                            // Check DownloadSourceRequest and refresh it every refreshMinute
                            this.requestsLoader();
                        }, refreshMinutes * 10000);
                        this.props.enqueueSnackbar('Transcoding created successfully, you will be notified via email once the video is ready.', {
                            variant: 'success', anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'center',
                            }
                        });
                    } else {
                        this.props.enqueueSnackbar('Failed to create request.', {
                            variant: 'warning', anchorOrigin: {
                                vertical: 'bottom',
                                horizontal: 'center',
                            }
                        });
                    }
                })
                .catch(error => {
                    this.props.enqueueSnackbar('Failed to create request.', {
                        variant: 'warning', anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'center',
                        }
                    });
                })

        }
    };


    render() {
        const {classes, theme} = this.props;
        const flex = {flexGrow: 1};

        const columns = [
            {
                name: "cid",
                label: "CID"
            },
            {
                name: "progress",
                label: "Progress"
            },
            {
                name: "source",
                label: "Source"
            },
            {
                name: "target",
                label: "Target"
            },
            {
                name: "suffix",
                label: "Suffix"
            },
            {
                name: "status",
                label: "Status"
            },
            {
                name: "updatedAt",
                label: "Updated at (timezone: " + Intl.DateTimeFormat().resolvedOptions().timeZone + ")"
            },
        ];
        let self = this;

        const options = {
            filterType: 'dropdown',
            pagination: true,
            selectableRows: false,
            print: false,
            viewColumns: false,
            customToolbar: function (columnMeta) {
                let toolBar = (<Button aria-label="Refresh" variant="contained" onClick={self.requestsLoader}
                                       className={classes.button}>
                    Refresh
                </Button>);
                return toolBar
            }
        };

        const containerStyle = {
            minHeight: '650px'
        };

        const checkButtonStyle = {
            marginLeft: '1em'
        };

        return (
            <React.Fragment>

                {/* {(sessionStorage.userEmail === "vishwajeet.vatharkar@vuclip.com" || sessionStorage.userEmail === "pooja.datrange@vuclip.com") && */}
                <Paper style={containerStyle}>

                    <Card>
                        <CardContent>
                            <Typography variant="h6" component="h3">New Transcoding Request</Typography>
                            <Grid container spacing={1}
                                  direction="row"
                                  justify="flex-start"
                                  alignContent="flex-start"
                            >

                                <Grid item sm={1}></Grid>
                                <Grid item sm={2}>
                                    <TextField fullWidth
                                               variant="outlined"
                                               label="Enter Content ID"
                                               value={this.state.cid}
                                               onChange={this.handleChange('cid')}
                                    />
                                </Grid>
                                <Grid item sm={2}>
                                    <TextField fullWidth
                                               variant="outlined"
                                               multiline={true}
                                               rows={3}
                                               label="Enter source"
                                               value={this.state.source}
                                               onChange={this.handleChange('source')}
                                    />
                                </Grid>
                                <Grid item sm={2}>
                                    <TextField fullWidth
                                               variant="outlined"
                                               label="Enter Target"
                                               multiline={true}
                                               rows={3}
                                               value={this.state.target}
                                               onChange={this.handleChange('target')}
                                    />
                                </Grid>
                                <Grid item sm={2}>
                                    <TextField fullWidth
                                               variant="outlined"
                                               label="Enter Suffix"
                                               value={this.state.suffix}
                                               onChange={this.handleChange('suffix')}
                                    />
                                </Grid>


                                <Grid item sm={2} style={{paddingTop: '10px'}}>
                                    <Button variant="contained" style={checkButtonStyle} color="primary"
                                            onClick={this.getDownloadableUrl.bind(this)}
                                    >
                                        Create Transcoding Request
                                    </Button>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                    <br/>

                    {
                        this.state.downloadableSourceUrlData && Object.keys(this.state.downloadableSourceUrlData).length > 0
                            ?
                            <Grid container spacing={0}
                                  direction="row"
                                  justify="space-around"
                                  alignItems="center">

                                <Grid item sm={12}>

                                    <MUIDataTable
                                        title={`My Source Video Requests`}
                                        data={this.state.downloadableSourceUrlData}
                                        columns={columns}
                                        options={options}
                                    />


                                </Grid>
                            </Grid>

                            :
                            null
                    }


                    {this.state.errorMessages && this.state.errorMessages.ERROR && this.state.errorMessages.ERROR.length > 0 &&
                    <Grid container spacing={0}>
                        <Grid item xs={1}></Grid>
                        <Grid item xs={10}>
                            {this.state.errorMessages.ERROR.map(function (errorMessage, index) {
                                return (<Typography variant='title' key={index} color='secondary'>
                                    Error : {errorMessage.message}
                                </Typography>)
                            })}
                        </Grid>
                        <Grid item xs={1}></Grid>
                    </Grid>}
                </Paper>
                {/* } */}
            </React.Fragment>
        );
    }
}

TranscodingHelperContainer.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};


export default withSnackbar(withStyles(styles, {withTheme: true})(TranscodingHelperContainer));
